import sortableHandle from 'ember-sortable/components/sortable-handle';

export default sortableHandle;

